// extracted by mini-css-extract-plugin
export default {"tag":"current-filter-tag_tag__+Dglc","labelPrefix":"current-filter-tag_labelPrefix__50n5d"};